import { DataAnalysis } from './data-analysis'
import { DataOverview } from './data-overview'

/** 智能体数据概览 */
export const AgentDashboardDataOverview = () => {
  return (
    <div className='w-full h-full flex flex-col overflow-auto gap-6'>
      <DataOverview />
      <DataAnalysis />
    </div>
  )
}
